class GameFactModelDTO {

    constructor(gameFactModelData){
        if(!gameFactModelData)
            return

        const {_id, name, provider, type} = gameFactModelData

        this._id = _id
        this.name = name

        this.provider = provider

        this.type = new TypeDTO(type)
    }
}

class TypeDTO {

    constructor(typeData){
        if(!typeData)
            return

        const {category, name, values, format, maxOccurence} = typeData

        this.name = name
        this.category = category
        this.format = format
        this.values = values
        this.maxOccurence = maxOccurence
    }
}

export default GameFactModelDTO